document.addEventListener('DOMContentLoaded', () => {
	const banner = document.querySelector('.cta-banner.is-fixed');
	if (!banner) return;

	const footer = document.querySelector('.main-footer');
	if (footer) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				banner.classList.toggle('is-footer-visible', entry.isIntersecting);
			});
		});

		observer.observe(footer);
	}

	// 上スクロールでヘッダーが出る時は追従バナーを隠し、下スクロールでは表示する（ヘッダーと逆の動き）
	let lastScrollY = window.scrollY;
	const hideThreshold = banner.offsetHeight;

	window.addEventListener('scroll', () => {
		const currentScrollY = window.scrollY;
		if (currentScrollY > lastScrollY) {
			banner.classList.remove('is-scroll-hidden');
		} else if (currentScrollY < lastScrollY && currentScrollY > hideThreshold) {
			banner.classList.add('is-scroll-hidden');
		} else {
			banner.classList.remove('is-scroll-hidden');
		}
		lastScrollY = currentScrollY;
	}, { passive: true });
});
